"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.advanceSearchTranslations = void 0;
exports.advanceSearchTranslations = {
    title: "Advanced Search",
    advanceSearch: "Advanced Search",
    allUsers: "All Users",
    loading: "Loading...",
    patientsCountHundred: "100+",
    updatePatientAddressMessage: "Please update the patient address",
    discipline: "Discipline",
    selectDiscipline: "Select Discipline",
    distance: "Distance",
    address: "Address: ",
    clinicians: "Clinicians",
    cliniciansFound: "{{count}} Clinicians Found",
    noneAssigned: "None assigned",
    loadingWorkloadDetails: "Loading workload details...",
    add: "Add",
    added: "Added",
    referral: "Referral",
    referralSent: "Referral Sent",
    noResults: "No clinicians found",
    noCliniciansFound: "No clinicians found",
    sendReferral: "Send Referral",
    assignedClinicians: "Assigned Clinicians",
    noCliniciansAssigned: "No clinicians assigned",
    patientsAtLocation: "{{count}} Patients at this location",
    careMap: "Care Map",
    searchAddress: "Search Address",
    searchAddressPlaceholder: "Enter an address to search nearby",
    locatingAddress: "Locating address…",
    addressNotFound: "We couldn't find that address. Try searching for it.",
    searchToSeeResults: "Search an address to see nearby patients and clinicians",
    distanceLabels: {
        two: "2 mi",
        five: "5 mi",
        ten: "10 mi",
        fifteen: "15 mi",
        twenty: "20 mi",
        twentyFive: "25 mi",
    },
};
